export class CanvasUtils {
  static canvasToPanZoomTransform(
    x: number,
    y: number,
    canvas: [width: number, height: number],
  ) {
    const transformX = canvas[0] / 2 - x;
    const transformY = canvas[1] / 2 - y;

    // this previously accepted a "useZoom" parameter
    // originated from react-zoom-pan-pinch
    // converting to using css zoom made it redudant as
    // css zoom doesn't change math calculations

    return { transformX, transformY };
  }
}
